import React from 'react';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import {
  generatePageStructure,
  nameById,
} from '@mm/state/helpers/filterable-select-helpers';
import FilterableSelect from '../FilterableSelect/FilterableSelect';
import { StoreState } from '@mm/state/store-interfaces';
import PageModel from '@mm/state/model/PageModel';
import './PageSelector.scss';

type OuterProps = {
  pages?: PageModel[];
  selectedPageId: number;
  updateFormPageId: (id: number) => void;
};

type PropsFromState = ReturnType<typeof mapStateToProps>;

type PropsFromWithHandlers = {
  onSelectPage: ReturnType<typeof onSelectPage>;
};

type InnerProps = PropsFromState & PropsFromWithHandlers;

type Props = OuterProps & InnerProps;

const PageSelectorBase = (props: Props) => {
  const { pages = [], selectedPageId, onSelectPage, pageGroups = [] } = props;
  return (
    <div>
      <div className="page-selector__page-select-container">
        <div className="page-selector__field-title">Dialogue</div>
        <FilterableSelect
          outerValue={nameById(selectedPageId, pages)}
          onChange={onSelectPage}
          suggestions={generatePageStructure(pages, pageGroups)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: StoreState) => ({
  pages: state.page.dropdown,
  pageGroups: state.pageGroup.entities,
});

const onSelectPage =
  ({ pages, updateFormPageId }) =>
  e => {
    const selectedPage = pages.find(item => item.id === Number(e));
    if (selectedPage) updateFormPageId(selectedPage.id);
  };

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps),
  withHandlers({ onSelectPage }),
);

export default enhance(PageSelectorBase);
